<template>
    <div>
        <HeaderSection icon="far fa-file-alt" title="Header & Footer">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="closeWindow">
                    Cerrar
                </el-button>
            </template>
        </HeaderSection>
        <el-form  @submit.native.prevent ref="specialForm" :model="specialForm" label-width="120px" label-position="top">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                        :rules="{ required: true,
                                                  message: 'Este campo es obligatorio',
                                                  trigger: 'change'}">

                        <label class="el-form-item__label">
                            Imagen para encabezado
                            <el-popover
                                placement="top-start"
                                trigger="hover"
                                width="500">
                                <p style="word-break: break-word !important;">
                                    *Las dimensiones máximas de la imagen corresponden a <b>2018 x 250 px</b>. <br>
                                    *Considerar que una imagen menor a estas dimensiones, podrá disminuir su calidad al imprimir documentos.
                                </p>
                                <el-button slot="reference"
                                           size="mini">
                                    <i class="fal fa-question"></i>
                                </el-button>
                            </el-popover>
                        </label>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <upload-photo @fileInfo="addFileToRequest"
                                              :type="1"
                                              :model="specialForm"
                                              :fileId="specialForm"
                                              :view="true" />
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        :rules="{ required: true,
                                                  message: 'Este campo es obligatorio',
                                                  trigger: 'change'}">

                        <label class="el-form-item__label">
                            Imagen para pie de página
                            <el-popover
                                placement="top-start"
                                trigger="hover"
                                width="500">
                                <p style="word-break: break-word !important;">
                                    *Las dimensiones máximas de la imagen corresponden a <b>2018 x 250 px</b>. <br>
                                    *Considerar que una imagen menor a estas dimensiones, podrá disminuir su calidad al imprimir documentos.
                                </p>
                                <el-button slot="reference"
                                           size="mini">
                                    <i class="fal fa-question"></i>
                                </el-button>
                            </el-popover>
                        </label>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <upload-photo @fileInfo="addFileToRequest"
                                              :type="2"
                                              :model="specialForm"
                                              :fileId="specialForm"
                                              :view="true" />
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import HeaderSection from '@/components/partials/HeaderSection';
    import UploadPhoto from '@/components/partials/UploadPhoto';
    export default {
        components:{
            UploadPhoto,
            HeaderSection

        },
        data(){
            return{
                specialForm: {}
            }
        },

        methods: {
            addFileToRequest(fileInfo){
                this.specialForm.file_id = fileInfo.id;
                this.specialForm.fileName = fileInfo.fileName;
                this.specialForm.fileNameHash = fileInfo.fileNameHash;
            },
            closeWindow(){
                setTimeout(() => {
                    window.close();
                }, 500);
            }
        }
    }
</script>

<style scoped>
    .files-to-upload > .el-upload > input { dispplay: hidden; }
</style>
